import { ConfirmDialog } from '@/components/confirm-dialog'
import { useFilters } from '@/hooks/useFilters'
import { listContactsQuery } from '@/queries/contact.query'
import { ContactService } from '@/services/contacts.service'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useContacts } from '../context/contacts-context'
import { ContactsMutateDrawer } from './contact-mutate-drawer'
import { ContactsImportDialog } from './contacts-import-dialog'

export function ContactsDialogs() {
  const { open, setOpen, currentRow, setCurrentRow } = useContacts()
  const { filters } = useFilters('/_authenticated/contacts/')
  const queryClient = useQueryClient()

  return (
    <>
      <ContactsMutateDrawer
        key='contact-create'
        open={open === 'create'}
        onOpenChange={() => setOpen('create')}
      />

      <ContactsImportDialog
        key='contacts-import'
        open={open === 'import'}
        onOpenChange={() => setOpen('import')}
      />

      {currentRow && (
        <>
          <ContactsMutateDrawer
            key={`contact-update-${currentRow.id}`}
            open={open === 'update'}
            onOpenChange={() => {
              setOpen('update')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            currentRow={currentRow}
          />

          <ConfirmDialog
            key='contact-delete'
            destructive
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            handleConfirm={() => {
              setOpen(null)
              setCurrentRow(null)
              toast.promise(ContactService.delete(currentRow.id), {
                loading: 'Deletando contato...',
                success: async () => {
                  await queryClient.invalidateQueries(listContactsQuery(filters))
                  return 'Contato deletado'
                },
                error: async () => {
                  await queryClient.invalidateQueries(listContactsQuery(filters))
                  return 'Erro ao deletar contato!'
                },
              })
            }}
            className='max-w-md'
            title={`Deletar este contato: ${currentRow.name} ?`}
            desc={
              <>
                Você está prestes a deletar um contato <strong>{currentRow.name}</strong>. <br />
                Esta ação não pode ser revertida.
              </>
            }
            confirmText='Deletar'
          />
        </>
      )}
    </>
  )
}
